import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import SubmitButton from '../components/SubmitButton';
import { useUserData } from '../context/UserData';
import HeadingCp from '../components/HeadingCp';
import SelectAddress from '../components/SelectAddress';

const TechServiceCallNew = () => {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const api = `${apiUrl}/service_crud.php`;
  const userData = useUserData();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const [employees, setEmployees] = useState([]);
  const [jobSite, setJobSite] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [serviceCallForm, setServiceCallForm] = useState({
    TROUBLE: '', CUSTOMER: '', ADDRESS: '',
    CALLED_BY: '', PHONE: '', TECH: '',
    NOTES: '', TIME: '', end_time: '',
    SCHEDULE_DATE: '', customer_id: ''
  });

  useEffect(() => {
    setLoading(true);
    const serviceCallList = async () => {
      if (id !== 'new') {
        try {
          const response = await axios.get(`${apiUrl}/service_crud.php?getDetail=${id}`, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          });
          
          if (response.data[0] === 'success') {
            setServiceCallForm(response.data[1]);
            
          } else {
            toast.error('No service calls found!', { position: 'top-center' });
          }
        } catch (error) {
          if (error.response && error.response.status === 401) {
            toast.error('Session expired. Please login again.', { position: 'top-center' });
            navigate('/login');
          } else if (error.response && error.response.status === 403) {
            toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
              position: 'top-center',
            });
          }
        } finally {
          setLoading(false);
        }
      }
    };
    serviceCallList();
  }, [apiUrl, navigate]);

  useEffect(() => {
    setLoading(true);
    const employees = async () => {
      try {
        const response = await axios.get(`${apiUrl}/service_crud.php?OnCallEmployees=true`, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        });
        const serviceCalls = Array.isArray(response.data) ? response.data : [];
        if (serviceCalls.length === 0) {
          toast.error('No service calls found!', { position: 'top-center' });
        }
        setEmployees(serviceCalls);
          //Find the “default” one and seed the form
          const def = serviceCalls.find(emp => emp.default);
          if (def) {
            setServiceCallForm(prev => ({
              ...prev,
              TECH: `${def.first_name} ${def.last_name}`,
            }));
          }        
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error('Session expired. Please login again.', { position: 'top-center' });
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
            position: 'top-center',
          });
        }
      } finally {
        setLoading(false);
      }
    };

    employees();
  }, [apiUrl, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if(name === 'ADDRESS')
    {
      setSelectedCompany(null);
      setServiceCallForm((prev) => ({
        ...prev,
        CUSTOMER:null,
      }));
    }
    setServiceCallForm((prevState) => ({
      ...prevState,
      [name]: value || '', // Ensuring the value is an empty string if it’s null or undefined
    }));
  };

  const handleCompanySelect = (newJobSite) => {
    if (newJobSite && newJobSite.full_address) {
      setSelectedCompany(newJobSite);
      setServiceCallForm((prev) => ({
        ...prev,
        CUSTOMER: newJobSite.customer_name,
        ADDRESS: newJobSite.full_address,
        customer_id: newJobSite.customer_id,
      }));
    } else {
      //console.error('Invalid company selected:', newJobSite);
    }
  };

  // Handle select change for technician  
  const handleSelectChange = (e) => {
    const value = e.target.value;
    setServiceCallForm((prevState) => ({ ...prevState, TECH: value }));
  };

  // append "****ON Call****"
  const handleSubmitServiceCall = async (e) => {
    e.preventDefault();
  // 1) Build a copy of the form with "****ON Call****" appended to NOTES
  const bodyData = {
    data: {
      ...serviceCallForm,
      NOTES: `****On Call**** ${serviceCallForm.NOTES}`
    },
    id: id,
    status: 'addServiceCall',
  };    
    try {
      const response = await axios.post(`${apiUrl}/service_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (response.data[0] === 'success') {
        toast.success('Service call successfully saved!', {
          position: 'top-center',
        });
        navigate(`/t/tservlist/`);
      } else {
        toast.error(response.data.error || 'Failed to save the service call.', {
          position: 'top-center',
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error('Session expired. Please login again.', {
          position: 'top-center',
        });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error('You do not have permission to edit this service call.', {
          position: 'top-center',
        });
      }
    }
  };


  return (
    <div className="bg-white py-8 px-4">
      <div className="max-w-lg mx-auto">
        <HeadingCp label="New Service Call" />

        <form onSubmit={handleSubmitServiceCall} className="space-y-6">
          <div className="space-y-4">
            {/* TROUBLE */}
            <div>
              <label htmlFor="TROUBLE" className="block text-sm font-medium">
                Trouble <span className="text-red-500">*</span>
              </label>
              <input
                type="text" name="TROUBLE" id="TROUBLE"
                value={serviceCallForm.TROUBLE}
                onChange={handleInputChange}
                required
                className="mt-1 block w-full rounded-md border-gray-300 p-2"
              />
            </div>

            {/* ADDRESS / SelectAddress */}
            <div>
              {serviceCallForm.ADDRESS ? (
                <input
                  type="text" name="ADDRESS" id="ADDRESS"
                  value={serviceCallForm.ADDRESS}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 p-2"
                />
              ) : (
                <SelectAddress
                  label="Select Job Site"
                  items={jobSite}
                  selectedItem={selectedCompany}
                  setSelectedItem={handleCompanySelect}
                  apiUrl={api}
                />
              )}
            </div>

            {/* CUSTOMER */}
            <div>
              <label htmlFor="CUSTOMER" className="block text-sm font-medium">
                Customer <span className="text-red-500">*</span>
              </label>
              <input
                type="text" name="CUSTOMER" id="CUSTOMER"
                value={serviceCallForm.CUSTOMER}
                onChange={handleInputChange}
                required
                className="mt-1 block w-full rounded-md border-gray-300 p-2"
              />
            </div>

            {/* Called By & Phone */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="CALLED_BY" className="block text-sm font-medium">
                  Called By <span className="text-red-500">*</span>
                </label>
                <input
                  type="text" name="CALLED_BY" id="CALLED_BY"
                  value={serviceCallForm.CALLED_BY}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 p-2"
                />
              </div>
              <div>
                <label htmlFor="PHONE" className="block text-sm font-medium">
                  Phone <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel" name="PHONE" id="PHONE"
                  value={serviceCallForm.PHONE}
                  onChange={handleInputChange}
                  required
                  className="mt-1 block w-full rounded-md border-gray-300 p-2"
                />
              </div>
            </div>

            {/* TECH */}
            <div>
              <label htmlFor="TECH" className="block text-sm font-medium">
                Technician
              </label>
              <select
                id="TECH" name="TECH"
                value={serviceCallForm.TECH}
                onChange={handleSelectChange}
                className="mt-1 block w-full rounded-md border-gray-300 p-2"
              >
                <option value="">Select Tech</option>
                {employees.map(emp => (
                  <option key={emp.id} value={`${emp.first_name} ${emp.last_name}`}>
                    {emp.first_name} {emp.last_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Date & Times */}
            {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div>
                <label htmlFor="SCHEDULE_DATE" className="block text-sm font-medium">
                  Date
                </label>
                <input
                  type="date" name="SCHEDULE_DATE" id="SCHEDULE_DATE"
                  value={serviceCallForm.SCHEDULE_DATE}
                  onChange={handleInputChange}
                  className="mt-1 block w-full rounded-md border-gray-300 p-2"
                />
              </div>
              <div>
                <label htmlFor="TIME" className="block text-sm font-medium">
                  Start Time
                </label>
                <input
                  type="time" name="TIME" id="TIME"
                  value={serviceCallForm.TIME}
                  onChange={handleInputChange}
                  className="mt-1 block w-full rounded-md border-gray-300 p-2"
                />
              </div>
              <div>
                <label htmlFor="end_time" className="block text-sm font-medium">
                  End Time
                </label>
                <input
                  type="time" name="end_time" id="end_time"
                  value={serviceCallForm.end_time}
                  onChange={handleInputChange}
                  className="mt-1 block w-full rounded-md border-gray-300 p-2"
                />
              </div>
            </div> */}

            {/* NOTES */}
            <div>
              <label htmlFor="NOTES" className="block text-sm font-medium">
                Notes
              </label>
              <textarea
                name="NOTES" id="NOTES"
                value={serviceCallForm.NOTES}
                onChange={handleInputChange}
                rows={4}
                className="mt-1 block w-full rounded-md border-gray-300 p-2"
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={() => navigate('/t/tservlist')}
              className="px-4 py-2 text-gray-700"
            >
              Cancel
            </button>
            <SubmitButton>
              {loading ? 'Saving…' : 'Save'}
            </SubmitButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TechServiceCallNew;
